<script lang="ts">
  // Schild: neutrale Kennzeichnung einer KATEGORIE -- Standort, Art,
  // Typ (docs/gestaltung.md, Baustein "Schild"). Nie eingefärbt: Farbe
  // heißt Zustand, und eine Kategorie ist kein Zustand. Genau das war
  // der Fehler der alten Backup-Etiketten (HOT rot auf jeder gesunden
  // Kette).
  //
  // `luecke` (gestrichelt) benennt, was FEHLT, ohne zu warnen -- z.B.
  // "nur WOB": keine Kopie außer Haus. Ob so eine Lücke ein Handgriff
  // ist, entscheidet nicht das Schild.
  import type { Snippet } from "svelte";

  let {
    luecke = false,
    title,
    children,
  }: { luecke?: boolean; title?: string; children: Snippet } = $props();
</script>

<span class="schild t-eyebrow" class:luecke {title}>{@render children()}</span>

<style>
  .schild {
    display: inline-flex;
    align-items: center;
    padding: 0.2rem 0.35rem;
    line-height: 1;
    white-space: nowrap;
    color: var(--fg-muted);
    border: 1px solid var(--border-strong);
    border-radius: var(--radius-sm);
  }
  .schild.luecke {
    color: var(--fg-subtle);
    border-style: dashed;
    font-weight: 500;
    letter-spacing: 0.02em;
    text-transform: none;
  }
</style>
